import type { SchemaToModel, Text } from '@blocksuite/store';
import { defineBlockSchema } from '@blocksuite/store';

// `toggle` type has been deprecated, do not use it
export type ListType = 'bulleted' | 'numbered' | 'todo' | 'toggle';

export interface PiqueListProps {
  type: ListType;
  text: Text;
  checked: boolean;
  collapsed: boolean;
  order: number | null;
  timestamps: Text; // Add timestamps field
  originalText: Text; // Add originalText field
  augmentedText: Text; // Add augmentedText field
  isAugmented: boolean; // Add isAugmented flag
}

// Define our custom list schema with additional fields
export const PiqueListBlockSchema = defineBlockSchema({
  flavour: 'affine:list', // Keep the same flavour to override the original
  props: internal =>
    ({
      type: 'bulleted',
      text: internal.Text(),
      checked: false,
      collapsed: false,
      order: null, // number type only for numbered list
      timestamps: internal.Text(), // Add timestamps field
      originalText: internal.Text(), // Add originalText field
      augmentedText: internal.Text(), // Add augmentedText field
      isAugmented: false, // Add isAugmented flag
    }) as PiqueListProps,
  metadata: {
    version: 1,
    role: 'content',
    parent: [
      'affine:note',
      'affine:database',
      'affine:list',
      'affine:paragraph',
      'affine:edgeless-text',
    ],
  },
});

export type PiqueListBlockModel = SchemaToModel<typeof PiqueListBlockSchema>;

